import { defineMessages } from 'react-intl';

export const messages: {
	connect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectLater: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationFail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationSuccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connect: {
		id: 'rovo.search.quick-find-3p.connect',
		defaultMessage: 'Connect {connectorName}',
		description: 'Button text to connect a third-party app',
	},
	connectLater: {
		id: 'rovo.search.quick-find-3p.connect-later',
		defaultMessage: 'Connect later',
		description: 'Button text to snooze the banner and connect later',
	},
	dismiss: {
		id: 'rovo.search.quick-find-3p.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Button text to dismiss the banner',
	},
	authorizationFail: {
		id: 'rovo.search.quick-find-authorization-fail',
		defaultMessage: 'Failed to connect to {product}.',
		description: 'Message displayed on flag when authorization fails.',
	},
	authorizationSuccess: {
		id: 'rovo.search.quick-find.authorization-success',
		defaultMessage: 'Account connected to {product}.',
		description: 'Message displayed on flag when authorization is successful.',
	},
});

// Full connector variant messages
export const fullConnectorMessages: {
	'admin-blessed-missing-results': {
		heading: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		body: {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
	'social-proof-high': {
		heading: {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
} = {
	'admin-blessed-missing-results': defineMessages({
		heading: {
			id: 'rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2',
			defaultMessage: 'Your admin added {connectorName}. ',
			description: 'Heading for admin-blessed-missing-results full connector variant',
		},
		body: {
			id: 'rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body',
			defaultMessage: 'Connect to see missing results',
			description: 'Body text for admin-blessed-missing-results full connector variant',
		},
	}),
	'social-proof-high': defineMessages({
		heading: {
			id: 'rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2',
			defaultMessage: '{teamConnectAppPercentage}% of your team have connected apps',
			description: 'Heading for social-proof-high full connector variant',
		},
	}),
};

// Smart link connector variant messages
export const smartLinkConnectorMessages: {
	'social-proof-low': {
		heading: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		body: {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
	'social-proof-high': {
		heading: {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
} = {
	'social-proof-low': defineMessages({
		heading: {
			id: 'rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2',
			defaultMessage: '{connectorName} is now available!',
			description: 'Heading for social-proof-low smart link connector variant',
		},
		body: {
			id: 'rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body',
			defaultMessage: 'Connect your account to see missing results',
			description: 'Body text for social-proof-low smart link connector variant',
		},
	}),
	'social-proof-high': defineMessages({
		heading: {
			id: 'rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3',
			defaultMessage: '{teamConnectAppPercentage}% of your team have connected apps',
			description: 'Heading for social-proof-high smart link connector variant',
		},
	}),
};

export const variantMessages: {
	'full-connector': {
		'admin-blessed-missing-results': {
			heading: {
				id: string;
				defaultMessage: string;
				description: string;
			};
			body: {
				id: string;
				defaultMessage: string;
				description: string;
			};
		};
		'social-proof-high': {
			heading: {
				id: string;
				defaultMessage: string;
				description: string;
			};
		};
	};
	smartlinks: {
		'social-proof-low': {
			heading: {
				id: string;
				defaultMessage: string;
				description: string;
			};
			body: {
				id: string;
				defaultMessage: string;
				description: string;
			};
		};
		'social-proof-high': {
			heading: {
				id: string;
				defaultMessage: string;
				description: string;
			};
		};
	};
} = {
	'full-connector': fullConnectorMessages,
	smartlinks: smartLinkConnectorMessages,
};
